import { PlusOutlined } from "@ant-design/icons";
import { useSubscription } from "@apollo/react-hooks";
import {
  Button,
  Card,
  Col,
  Empty,
  Form,
  Input,
  Layout,
  Row,
  Table,
  Tooltip,
} from "antd";
import Avatar from "antd/lib/avatar/avatar";
import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router";
import { AddEmployeeDrawer } from "../../../Components/Drawers/AddEmployee";
import { Loader } from "../../../Components/Loader";
import { CustIcon } from "../../../Components/Svgs";
import { SUBSCRIBE_EMPLOYEE_LIST } from "../../../Graphql/subscriptions";
import Empty_SendFirstAnnouncement from "../../../Assets/Images/Empty/Empty_EscalationVector.svg";
import "./EmployeesList.less";

const { REACT_APP_ASSETS_URL } = process.env;
const { Content } = Layout;

export const EmployeesListPage = () => {
  const [fetchParams, setFetchParams] = useState({
    user_id: localStorage.getItem("user_id"),
  });
  const [showAddNewEmployeeDrawer, setShowAddNewEmployeeDrawer] =
    useState(false);

  const history = useHistory();

  const { data, loading } = useSubscription(SUBSCRIBE_EMPLOYEE_LIST, {
    fetchPolicy: "cache-and-network",
    variables: fetchParams,
    shouldResubscribe: true,
  });

  const onFilterChange = (values) => {
    for (const [key, value] of Object.entries(values)) {
      if (!!value) {
        values[key] = "%" + value + "%";
      } else {
        delete values[key];
      }
    }
    values.user_id = localStorage.getItem("user_id");
    setFetchParams(values);
  };

  const columns = [
    {
      title: "Employee Name & Role",
      render: (text, record) => {
        return (
          <div className="d-flex align-items-center">
            <div className="mr-3 employeeImage">
              <Avatar
                src={
                  record.employee_details.profile_image
                    ? REACT_APP_ASSETS_URL +
                      record.employee_details.profile_image
                    : undefined
                }
              >
                {record.employee_details.first_name?.charAt(0) +
                  record.employee_details.last_name?.charAt(0)}
              </Avatar>
            </div>
            <div className="d-flex flex-column">
              <div className="employeeName">
                {record.employee_details.full_name}
              </div>
              <div className="employeeRole">
                {
                  record.employee_details.user_location_maps[0].jobRoleDetails
                    .role_name
                }
              </div>
            </div>
          </div>
        );
      },
    },
    {
      title: "Employee Code",
      render: (text, record) => {
        return <span>{record.employee_details.employee_code}</span>;
      },
    },
    {
      title: "Employee Email",
      render: (text, record) => {
        return <span>{record.employee_details.email}</span>;
      },
    },
    {
      title: "Location",
      render: (text, record) => {
        return <span>{record.location_details.location_name}</span>;
      },
    },
  ];
  return (
    <Fragment>
      <Content className="site-body-layout mt-5">
        <>
          {data?.employeeList.length > 0 && (
            <Row>
              <Col xs={24}>
                <Button
                  shape="round"
                  icon={<CustIcon type="plus" className="mr-2" />}
                  className="d-flex align-items-center addNewEmployee"
                  size="large"
                  onClick={() => setShowAddNewEmployeeDrawer((c) => !c)}
                >
                  Add new employee
                </Button>
              </Col>
            </Row>
          )}
          <div className="employeeListSec">
            <div className="employeeSearch mt-3">
              <Form name="basic" onFinish={onFilterChange}>
                <Row gutter={15}>
                  <Col xs={24} md={8} lg={5}>
                    <Tooltip
                      trigger={["focus"]}
                      title="Employee name"
                      placement="topLeft"
                      overlayClassName="numeric-input"
                    >
                      <Form.Item name="name">
                        <Input placeholder="Employee name" />
                      </Form.Item>
                    </Tooltip>
                  </Col>
                  <Col xs={24} md={8} lg={3}>
                    <Tooltip
                      trigger={["focus"]}
                      title="Employee code"
                      placement="topLeft"
                      overlayClassName="numeric-input"
                    >
                      <Form.Item name="employee_code">
                        <Input placeholder="Code" />
                      </Form.Item>
                    </Tooltip>
                  </Col>
                  <Col xs={24} md={8} lg={4}>
                    <Tooltip
                      trigger={["focus"]}
                      title="Employee role"
                      placement="topLeft"
                      overlayClassName="numeric-input"
                    >
                      <Form.Item name="role">
                        <Input placeholder="Employee role" />
                      </Form.Item>
                    </Tooltip>
                  </Col>
                  <Col xs={24} md={8} lg={4}>
                    <Tooltip
                      trigger={["focus"]}
                      title="Employee email"
                      placement="topLeft"
                      overlayClassName="numeric-input"
                    >
                      <Form.Item name="email">
                        <Input placeholder="Employee email" />
                      </Form.Item>
                    </Tooltip>
                  </Col>
                  <Col xs={24} md={8} lg={4}>
                    <Tooltip
                      trigger={["focus"]}
                      title="Location"
                      placement="topLeft"
                      overlayClassName="numeric-input"
                    >
                      <Form.Item name="location">
                        <Input placeholder="Location" />
                      </Form.Item>
                    </Tooltip>
                  </Col>
                  <Col
                    xs={24}
                    md={7}
                    lg={4}
                    className="text-md-right text-center"
                  >
                    <Form.Item>
                      <Button
                        type="primary"
                        size="large"
                        shape="round"
                        htmlType="submit"
                        className="px-5"
                      >
                        Search
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </div>
            <Card className="employeeTableList">
              {loading ? (
                <Loader />
              ) : !data?.employeeList.length ? (
                <Card className="h-100 w-100">
                  <div className=" d-flex flex-column align-items-center justify-content-center py-5">
                    <Empty
                      image={Empty_SendFirstAnnouncement}
                      description="Create new employee now!"
                      className=""
                    />
                    <Button
                      shape="round"
                      icon={<CustIcon type="plus" className="mr-2" />}
                      className="addNewEmployee"
                      size="large"
                      onClick={() => setShowAddNewEmployeeDrawer((c) => !c)}
                    >
                      Add new employee
                    </Button>
                  </div>
                </Card>
              ) : (
                <Table
                  onRow={(record) => {
                    return {
                      onClick: () => {
                        history.push(
                          "/employee/" +
                            record.employee_details.user_id +
                            "/personal-details"
                        );
                      },
                    };
                  }}
                  columns={columns}
                  dataSource={data?.employeeList}
                  loading={{ spinning: loading, indicator: <Loader /> }}
                />
              )}
            </Card>
          </div>
        </>
      </Content>
      {showAddNewEmployeeDrawer && (
        <AddEmployeeDrawer
          visible={showAddNewEmployeeDrawer}
          toggleDrawer={() => setShowAddNewEmployeeDrawer((c) => !c)}
        />
      )}
    </Fragment>
  );
};
